export default `#version 300 es
precision highp float;
#define GLSLIFY 1

float msdf(sampler2D map, vec2 uv) {
    vec3 tex = texture(map, uv).rgb;

    float signedDist = max(min(tex.r, tex.g), min(max(tex.r, tex.g), tex.b));
    float d = fwidth(signedDist);

    return smoothstep(0.5 - d, 0.5 + d, signedDist);
}

in vec2 vUv;

out vec4 fragColor[3];

uniform sampler2D tMap;
uniform vec3 uColor;

void main() {
    float alpha = texture(tMap, vUv).a;

    if(alpha < 0.4f)
        discard;

    fragColor[2] = vec4(uColor, alpha * 1.7f);
}`